const config = require("../config")
const url = config.base_dev_url + "v2/farm/basicInfo"

module.exports = {
    // 获取农场基本信息表单数据
    fetchBasicFarmFormData: {
        url: url + "/formData",
        type: "get",
    },
    // 保存农场基本信息
    saveBasicFarmInfo: {
        url: url + "/save",
        type: "post",
    },
    // 自己创建农场基于专家
    saveBasicFarmInfoByExpert: {
        url: config.base_dev_url + "v2/farm/selfCreateFarmByExpert",
        type: "post",
    },
    // 自己创建农场基于专家
    saveBasicFarmInfoByExpertV3: {
        url: config.base_dev_url + "v3/farm/selfCreateFarmByExpert",
        type: "post",
    },
    // 保存草稿
    saveDraft: {
        url: url + "/saveDraft",
        type: "post",
    },
    // 新增自定义选项
    addCustomOption: {
        url: url + "/option/add",
        type: "post",
    },
    // 删除自定义选项
    deleteCustomOption: {
        url: url + "/option/delete",
        type: "get",
    },
    // 更新自定义选项
    updateCustomOption: {
        url: url + "/option/update",
        type: "post",
    },
    // 查询农场主体详情
    fetchFarmSubjectDetail: {
        url: config.base_dev_url + "farm_subject/getSubjectDetail",
        type: "get",
    },
    //更新分区最后查看时间
    updateLastViewTime: {
        url: config.base_dev_url + "region/updateLastViewTime",
        type: "get",
    },
    //根据农场主体ID查询其下所有农场的分区信息（品种分区 + 问题分区）
    fetchRegionInfo: {
        url: config.base_dev_url + "farm_subject/listRegionAndProblemZonesBySubjectId",
        type: "get",
    },
    //编辑农场主体问题分区（两层菜单结构提交）
    ediRegionZone: {
        url: config.base_dev_url + "farm_subject/editRegionAndProblemZonesBySubjectId",
        type: "post",
    },
    //保存 / 重置问题分区图片
    saveProblemZoneImage: {
        url: config.base_dev_url + "farm_problem_zone_image/saveByProblemZoneId",
        type: "post",
    },
    //根据农场主体ID查询其下“已配置”的问题分区列表，
    fetchProblemZoneList: {
        url: config.base_dev_url + "farm_subject/listRegionsAndProblemZonesMapBySubjectId",
        type: "get",
    },
}